module.exports = __webpack_public_path__ + "img/Fisica II.f85102bb.png";